import { FetchBackoffAbortError } from '@electric-sql/client'

/** Electric uses this error only when an in-flight shape request is intentionally interrupted. */
export function isExpectedElectricCancellation(error: unknown): boolean {
  return error instanceof FetchBackoffAbortError
}
